"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerTextInputPlaceholderStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _inputFieldBaseProps = require("../../../../util/inputFieldBaseProps");
var _formInputTheme = require("../../../textinput/styled/formInputTheme");
const {
  neutralDark20
} = _designTokens.lodestarColors;
const DatePickerTextInputPlaceholderStyled = (0, _styled.default)("div")`
    position: absolute;
    box-sizing: border-box;
    outline: none;

    // This needs to show on top of the input, but not be clickable.
    z-index: 1;
    pointer-events: none;

    font-weight: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _formInputTheme.formInputTheme.fontWeight(themeMode);
}};
    font-size: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _formInputTheme.formInputTheme.fontSize.box(themeMode);
}};
    padding-top: ${_ref3 => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref3;
  return _formInputTheme.formInputTheme.placeholderTop[(0, _inputFieldBaseProps.getInputFieldHeightValue)(themeMode, inputFieldHeight)](themeMode);
}};
    padding-left: calc(2px + ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _formInputTheme.formInputTheme.padding.default.rest(themeMode);
}}px);

    .sds__user-input {
        color: transparent;
    }

    .sds__format-placeholder {
        color: ${(0, _designTokensReact.color)("color--text--neutral--weak", neutralDark20)};
    }
`;
exports.DatePickerTextInputPlaceholderStyled = DatePickerTextInputPlaceholderStyled;
//# sourceMappingURL=DatePickerTextInputPlaceholderStyled.js.map